import React from 'react';
import TopHead from './TopHead';
import MovieSlider from './MovieSlider';
import TopRatedMovies from './TopRatedMovies';

const Home = () => {
    return (
        <div>
            {/* All Components for Home */}
            <TopHead />
            <MovieSlider />
            <TopRatedMovies />
        </div>
    );
}

export default Home;
